import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

import { firstValueFrom, Observable } from 'rxjs';
import { downloadXlsxDocument, normalizeOperator } from '../../../common/functions';
import { notifyAndTrackError } from '../../../common/error';

import { InsectaServiceBase } from '../insecta.base.service';
import { ISearchRequest, ISearchResult } from '../insecta.models';
import { AppInsightsService } from '../../app-insights.service';

@Injectable({
  providedIn: `root`
})
export class MetricsService extends InsectaServiceBase {
  private readonly appInsights = inject(AppInsightsService);
  private readonly msgService = inject(MessageService);

  public getInstanceMetrics(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/admin/metrics/table`, `v1`, request);
  }
  public async getInstanceMetricsXlsx(request: ISearchRequest): Promise<void> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    await firstValueFrom(this.fetchBlob(`/admin/metrics/export`, `v1`, request))
      .then((response) => {
        const filename = `Metrics-${new Date().toISOString().slice(0, 10)}.xlsx`;
        downloadXlsxDocument(response, filename);
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'MetricsService', action: 'GetInstanceMetricsXlsx' });
      });
  }
}
